
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import NevronIcon from '@/components/NevronIcons.vue';

@Component({
  components: { NevronIcon },
})
export default class NevronSearch extends Vue {
  /** Props **/
  @Prop({ default: false }) noXPadding!: boolean;
  @Prop({ default: false }) hasFilter!: boolean;

  /** Emits **/
  @Emit('openFilter')
  emitOpenFilter() {
    return true;
  }
}
